import React from "react";
import {PostToPbx} from "./http-post";
import {GetUserToken} from "./token";

export const fetchDataEntity = async (stateEntity, moduleEntity, table, _this, noCondition) => {
    _this.setState({
        isLoading: true,
        [stateEntity]: [],
    })
    let user = GetUserToken();
    if(user===null){
        user={
            OrgCode:"",
            Username:"",
            Role:""
        }
    }

    let hub = {
        Org: user.OrgCode,
        Username: user.Username,
        Role: user.Role
    }
    if (typeof noCondition !== "undefined") {
        hub = {}
    }
    /*if (user.Role !== "super") {
        hub = {
            Org: user.OrgCode,
            Username: user.Username,
            Role: user.Role
        }
    }*/
    let endpoint = "/" + moduleEntity + "/list/" + table;
    await PostToPbx(hub, endpoint, async (data) => {
        console.log("):(--->fetchData " + stateEntity + " -> " + moduleEntity + " -> " + table + " > response: ", data," > ",user);
        _this.setState({
            isLoading: false,
        })
        if (data === null) {
            alert("Server connection Error! try again later");
            return
        }

        let ls = [];
        if (stateEntity === "Companies" && moduleEntity === "client/entity") {
            if (user.Role !== "super") {
                for (let i in data.RESULT) {
                    const row = data.RESULT[i];
                    if (row.CustomerNumber === user.OrgCode || row.CustomerNumber === user.Org ) {
                        ls.push(row)
                    }
                }
            } else {
                ls = data.RESULT
            }

        } else {
            ls = data.RESULT
        }

        _this.setState({
            isLoading: false,
            [stateEntity]: ls,
        })
    });
}
